import i18n from "i18next";
import { initReactI18next } from "react-i18next";

import ptBR from "./locales/pt-BR.json";
import en from "./locales/en.json";
import es from "./locales/es.json";

const STORAGE_KEY = "portal-externo-language";

const SUPPORTED_LANGUAGES = ["pt-BR", "en", "es"];

function getDefaultLanguage(): string {
    const saved = localStorage.getItem(STORAGE_KEY);
    if (saved) return saved;

    const browserLang = navigator.language;

    if (SUPPORTED_LANGUAGES.includes(browserLang)) return browserLang;

    const baseLang = browserLang.split("-")[0];
    const match = SUPPORTED_LANGUAGES.find(
        (lang) => lang === baseLang || lang.startsWith(baseLang + "-"),
    );
    if (match) return match;

    return "pt-BR";
}

const savedLanguage = getDefaultLanguage();

i18n.use(initReactI18next).init({
    resources: {
        "pt-BR": { translation: ptBR },
        en: { translation: en },
        es: { translation: es },
    },
    lng: savedLanguage,
    fallbackLng: "pt-BR",
    interpolation: {
        escapeValue: false,
    },
});

i18n.on("languageChanged", (lng) => {
    localStorage.setItem(STORAGE_KEY, lng);
});

export default i18n;
